import React , { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// TS type
import { RootState } from '@redux/store';
import { IETItem } from '@redux/common';

// shared component
import Counter from '@component/Common/counter';
import Lock from '@svg/Lock'; // svg component

// common function
import { convertTicketNum, addSeparator, getSessionInfo } from '@libs/core';

// redux actions
import { setTicketNum, setGTicketErr } from '@redux/GDS/actions';

// plugin
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

interface IGTicketProps {
    isCrossell?: boolean;
}

const TicketBlock: React.FC<IGTicketProps> = (props) => {
    const { isCrossell } = props;
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { GDetail, calendar, ticketNum, GNowListData, GTicketErr, session, sessionPicked } =
        useSelector((state: RootState) => state.GDS);
    const { GListData, isLogin, isErpOrder } = useSelector((state: RootState) => state.Common);
    const hasCalendar = GNowListData?.ExpectedUseDay;
    // const ETdata = hasCalendar ? GDetail.CalendarDate[calendar]?.ETItem : GDetail.ETItem;
    const saleCurrency = GListData.SaleCurrency;
    const [ETdata, setETdata] = React.useState<IETItem[]>(null);

    useEffect(() => {
        if (!GDetail) return;
        if (!hasCalendar) {
            setETdata(GDetail.ETItem);
            return;
        }
        if (!GDetail.Sessions) {
            Object.keys(GDetail.CalendarDate).length !== 0
                ? setETdata(GDetail.CalendarDate[calendar]?.ETItem)
                : setETdata(GDetail.ETItem)
            return;
        }
        if (session && sessionPicked) {
            setETdata(getSessionInfo({ session, sessionPicked })?.ETItem);
        }
    }, [sessionPicked, GDetail, calendar, ticketNum, session]);

    useEffect(() => {
        if (!session || !sessionPicked) return;
        dispatch(
            setTicketNum(convertTicketNum(getSessionInfo({ session, sessionPicked })?.ETItem))
        );
    }, [sessionPicked?.SessionUUID]);

    const ticketComponent = () => {
        return ticketNum && ETdata ? (
            ETdata.map((item) => {
                return (
                    <div 
                        className={cx("ticket",{
                            hasmembertag: item.SalePrice > 0 && !isLogin
                        })} 
                        key={item.ItemSeq}
                    >
                        <div className="ticketTitle">
                            {item.Name}
                            {/* <span>{item?.Note}</span> */}
                        </div>
                        <div className="ticketPrice">
                            <div className="priceWrap">
                                <div className='normalPriceContent'>
                                    {/* 原價 */}
                                    {!!item?.ListPrice &&
                                        item.ListPrice > 0 &&
                                        item.ListPrice > item.SalePrice_NonMember && (
                                            <span className="price originalPrice">
                                                {`${saleCurrency} ${addSeparator(item.ListPrice)}`}
                                            </span>
                                        )
                                    }
                                    {/* 售價&會員價 */}
                                    <span className="price">
                                        { isCrossell && item.SalePrice_Spread > 0 &&
                                            <span className='originalPrice'>
                                                {saleCurrency} {addSeparator(item.SalePrice_NonMember)}
                                            </span>
                                        }
                                        {/* 有電話單 就直接顯示會員價(會員價 !== 0 ) */}
                                        {/* 如果有登入 + 會員價 !== 0 就將售價改成顯示會員價 */}
                                        {
                                            !isErpOrder
                                            ? ( isLogin
                                                ? item.SalePrice > 0
                                                    ? isCrossell && item.SalePrice_Spread > 0
                                                        ? `${saleCurrency} ${addSeparator(item.SalePrice_NonMember - item.SalePrice_Spread)}`
                                                        : `${saleCurrency} ${addSeparator(item.SalePrice)}`
                                                    : `${saleCurrency} ${addSeparator(item.SalePrice_NonMember)}`
                                                : `${saleCurrency} ${addSeparator(item.SalePrice_NonMember)}`
                                            ) : (
                                                item.SalePrice > 0
                                                    ? `${saleCurrency} ${addSeparator(item.SalePrice)}`
                                                    : `${saleCurrency} ${addSeparator(item.SalePrice_NonMember)}`
                                            )
                                        }
                                    </span>
                                </div>
                                {/* 會員價lock版 */}
                                { !isErpOrder && !isLogin && item.SalePrice > 0 && (
                                    <div className='memberPriceContent'>
                                        <Lock/>
                                        <span className="price memberPrice">
                                            {`${t('noTHSR.ticket.memberPrice')} ${addSeparator(item.SalePrice)}`}
                                        </span>
                                    </div>
                                    )
                                }
                            </div>
                            <Counter
                                ticketSeq={item.ItemSeq}
                                lowQty={
                                    item.LowQty === 0 || 
                                    item.LowQty > item.Mutiple 
                                        ? item.Mutiple === 1 
                                            ? Math.floor(item.LowQty / item.Mutiple)
                                            : item.Mutiple * (Math.floor(item.LowQty / item.Mutiple) + 1)
                                        : item.Mutiple
                                }
                                maxNum={item.HighQty}
                                defaultValue={ticketNum[item.ItemSeq]}
                                onChange={(num: number) => {
                                    dispatch(
                                        setTicketNum({
                                            ...ticketNum,
                                            ...{ [item.ItemSeq]: num },
                                        })
                                    );
                                    GTicketErr && dispatch(setGTicketErr(''));
                                }}
                                multiple={item.Mutiple}
                            />
                        </div>
                    </div>
                );
            })
        ) : (
            <div className="noTickets">{t('noTHSR.ticket.sorryForNoAvailableTickets')}</div>
        );
    };

    return <div className="tickets">{ticketComponent()}</div>;
};

export default TicketBlock;
